export enum PurchaseStatusEnum {
  Pending,
  Approved,
  Refused,
}
